module['exports'] = [
  'عمیر',
  'ابراہیم',
  'احسن',
  'عبداللہ',
  'عثمان',
  'حمزہ',
  'سیف',
  'ولید',
  'وسیم',
  'محسن',
  'یاسین',
  'کمال',
  'عادل',
  'اویس',
  'مسود',
  'شفیع',
  'فرہان',
  'ممتاز',
];
